import './style.css'
import App from './App.vue'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { router } from './router/router'
import { captureException } from './composables/usePostHog'
import { i18n } from './i18n.js'

const pinia = createPinia();
const app = createApp(App);
app.use(router);
app.use(pinia);
app.use(i18n);

// Capture unhandled synchronous errors (e.g. script errors, setTimeout throws).
window.onerror = (message, source, lineno, colno, error) => {
  captureException(error ?? new Error(String(message)), { source, lineno, colno })
}

// Capture unhandled promise rejections.
window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason instanceof Error ? event.reason : new Error(String(event.reason))
  captureException(error)
})

// Forward Vue component errors to PostHog.
// The window-level listeners above do not see errors that Vue catches internally
// (component lifecycle hooks, watchers, render errors) — this handler covers those.
app.config.errorHandler = (err, _instance, info) => {
  captureException(err, { vue_info: info })
  // Re-throw so the browser console still shows the error.
  console.error('[Vue errorHandler]', info, err)
}

app.mount('#app');

// Register service worker for push notifications
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').catch((err) => {
    console.warn('Service worker registration failed:', err)
  })
}
